<template>
    <div class="enquiry-form-component text-center">
        <div class="form-group form-label-group">
            <input
                type="text"
                class="form-control"
                v-model="name"
                placeholder="Name *"
                required
            />
            <label for="name">Name *</label>
        </div>

        <div class="form-group form-label-group">
            <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="Email Address *"
                required
            />
            <label for="name">Email Address *</label>
        </div>

        <div class="form-group form-label-group">
            <input
                type="text"
                class="form-control"
                v-model="telephone"
                placeholder="Telephone"
            />
            <label for="name">Telephone</label>
        </div>

        <div class="form-group form-label-group">
            <textarea
                v-model="enquiry"
                rows="10"
                class="form-control"
                placeholder="Your enquiry *"
                required
            ></textarea>
            <label for="name">Your enquiry *</label>
        </div>

        <div class="form-group form-label-group mb-4">
            <select v-model="customisationId" class="form-control">
                <option :value="null">Attach a customisation</option>
                <option v-for="customisation in customisations" :value="customisation.id" :key="customisation.id">
                    {{ customisation.name }}
                </option>
            </select>
        </div>

        <p>
            We'd love to keep in touch to let you know about our new
            developments and home releases as well as exclusive offers. Your
            privacy is incredibly important to us, so we will keep your details
            safe and will never pass them onto other third parties.
        </p>

        <div class="custom-control custom-checkbox mb-4">
            <input
                type="checkbox"
                class="custom-control-input"
                id="marketing-opt-in"
                v-model="marketingOptIn"
            />
            <label class="custom-control-label" for="marketing-opt-in"
                >I'd like to receive offers and updates from Castle Green</label
            >
        </div>

        <button class="btn btn-primary" type="button" @click="sendEnquiry">
            Send Enquiry
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: null,
            email: null,
            telephone: null,
            enquiry: null,
            customisationId: null,
            marketingOptIn: false
        };
    },

    created() {
        if (this.user) {
            this.name = this.user.name;
            this.email = this.user.email;
            this.telephone = this.user.phone;
        }
    },

    props: {
        customisations: {
            type: Array,
            required: false,
            default: () => [],
        },

        user: {
            type: Object,
            required: false,
            default: () => {},
        },
    },

    methods: {
        validate() {
            if (this.name && this.email && this.enquiry) {
                return true;
            }

            return false;
        },

        sendEnquiry() {
            if (!this.validate()) {
                return notyf.error("Please fill in all required fields.");
            }

            axios
                .post("/api/v1/enquiry/store", {
                    name: this.name,
                    email: this.email,
                    phone: this.telephone,
                    enquiry: this.enquiry,
                    customisation_id: this.customisationId,
                    marketing: this.marketingOptIn
                })
                .then(response => {
                    notyf.success("Your enquiry was sent successfully.");
                    this.name = null;
                    this.email = null;
                    this.telephone = null;
                    this.enquiry = null;
                    this.customisationId = null;
                    this.marketingOptIn = false;

                    $('#enquiry-form-modal').modal('hide');
                })
                .catch(error => {
                    notyf.error("An error occurred while sending the enquiry. Please try again in a few moments.");
                });
        }
    }
};
</script>
